import {F3ExcelsiorForecastStoreLambda} from '@amzn/f3-excelsior-forecast-store-lambda';
import {useAsync} from './use-async';
import {wrapOnErrorListener} from '../common';
import {DependencyList, useCallback} from 'react';

export function useGetDashboardUrlByDashboardName(
    clientConfiguration: F3ExcelsiorForecastStoreLambda.Types.ClientConfiguration,
    request: F3ExcelsiorForecastStoreLambda.Types.GetDashboardUrlByDashboardNameInput,
    immediate: boolean,
    onErrorListener: (e: any) => void,
    deps: DependencyList,
    client = new F3ExcelsiorForecastStoreLambda(clientConfiguration)
) {
    return useAsync(
        useCallback(() => wrapOnErrorListener(client.getDashboardUrlByDashboardName(request).promise(), onErrorListener), deps),
        immediate
    );
}
